const TOKEN_KEY = 'token';
const REMEMBER_KEY = 'rememberMe';

const safeLocalGet = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

const safeLocalSet = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Ignore storage write failures.
  }
};

const safeLocalRemove = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch {
    // Ignore storage cleanup failures.
  }
};

const safeSessionRemove = (key: string): void => {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // Ignore storage cleanup failures.
  }
};

/** Get stored token from localStorage (supports multi-tab and hard refresh) */
export function getStoredToken(): string | null {
  return safeLocalGet(TOKEN_KEY);
}

/** Store token in localStorage — always persistent for multi-tab support */
export function storeToken(token: string, rememberMe: boolean): void {
  safeLocalSet(TOKEN_KEY, token);
  if (rememberMe) {
    safeLocalSet(REMEMBER_KEY, 'true');
  } else {
    safeLocalRemove(REMEMBER_KEY);
  }
  // Clean up any legacy sessionStorage token
  safeSessionRemove(TOKEN_KEY);
}

/** Clear token from storage */
export function clearStoredToken(): void {
  safeLocalRemove(TOKEN_KEY);
  safeSessionRemove(TOKEN_KEY);
  safeLocalRemove(REMEMBER_KEY);
  safeLocalRemove('refreshToken');
}

/** Check if user previously chose "Remember Me" */
export function getRememberMePreference(): boolean {
  return safeLocalGet(REMEMBER_KEY) === 'true';
}
